/**
 * Generic Form Component
 * ======================
 * Reusable Alpine.js component for form handling.
 *
 * Usage in Twig:
 * <div x-data="form()">
 *   <form @submit.prevent="submitForm()">
 *     ...
 *   </form>
 * </div>
 */

const STATE_IDLE = 'idle'
const STATE_LOADING = 'loading'
const STATE_SUCCESS = 'success'
const STATE_ERROR = 'error'

export default () => ({
  state: STATE_IDLE,
  errorMessage: '',

  isIdle() {
    return this.state === STATE_IDLE
  },

  isLoading() {
    return this.state === STATE_LOADING
  },

  isSuccess() {
    return this.state === STATE_SUCCESS
  },

  isError() {
    return this.state === STATE_ERROR
  },

  async submitForm() {
    if (!this.isIdle() && !this.isError()) return

    this.state = STATE_LOADING
    this.errorMessage = ''

    try {
      const form = this.$refs.form || this.$el.querySelector('form')
      if (!form) {
        throw new Error('Form element not found')
      }

      const formData = new FormData(form)

      const response = await fetch('/', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      })

      const data = await response.json()

      if (!response.ok || data.errors) {
        throw new Error(data.message || 'An error occurred. Please try again.')
      }

      const redirectUrl = form.querySelector('input[name="redirectUrl"]')?.value

      // Track successful form submission
      window.umami?.track('Signup button')

      if (redirectUrl) {
        // Stay in loading state until redirect completes
        window.location.href = redirectUrl
      } else {
        this.state = STATE_SUCCESS
      }
    } catch (error) {
      console.error('Form submission error:', error)
      this.state = STATE_ERROR
      this.errorMessage = error.message || 'An error occurred. Please try again later.'
    }
  },

  reset() {
    this.state = STATE_IDLE
    this.errorMessage = ''
  },
})
